export default __webpack_public_path__ + "static/media/Z_sound.0673b408.mp3";